export default input => {
  if (typeof input !== 'string' || !input?.length) return null;
  const [firstLetter, ...restOfWord] = input;
  return firstLetter.toUpperCase() + restOfWord.join('');
};
